import { ContactItemDto, SortDirectionDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { CustomTableStateModel } from '@/components/table/model/CustomTableState.model.ts';
import {
  ContactsSearchFormModel,
  initialContactsSearchFormModel,
} from '@/views/contacts/components/table/model/ContactsSearchForm.model.ts';

export type ContactsTableState = CustomTableStateModel<
  string,
  ContactsSearchFormModel,
  ContactItemDto
>;

export const initialContactsTableState = (params: {
  isAlreadyInCustomer?: SelectSearchOptionModel<boolean>;
}): ContactsTableState => {
  const { isAlreadyInCustomer } = params;
  return {
    data: {
      items: [],
      totalPages: 0,
      totalResults: 0,
    },
    page: 0,
    pageSize: 10,
    params: initialContactsSearchFormModel({ isAlreadyInCustomer }),
    sortBy: '',
    sortOrder: SortDirectionDto.Asc,
  };
};
